import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { lowerCase } from "lodash";
import { useState } from "react";
import { Badge, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SubscriptionPlan } from "./types";
import { mixpanelTrack } from "../../utils/mixpanel-utils";

interface Props {
    subscriptionPlans: SubscriptionPlan[];
    onPlanChange: (data: SubscriptionPlan) => void;
}

function SubscriptionPlanComponent({ subscriptionPlans, onPlanChange }: Props) {
    const [selectedPlan, setSelectedPlan] = useState<SubscriptionPlan | null>(
        subscriptionPlans[0]
    );
    const { t } = useTranslation();

    function handlePlanChange(plan: SubscriptionPlan) {
        setSelectedPlan(plan);
        onPlanChange(plan);
        mixpanelTrack(`Clicked ${plan.name}`, {
            step: "Subscription",
            flow: "External Subscription",
        });
    }

    return (
        <Col className="plans-wrapper">
            {subscriptionPlans &&
                subscriptionPlans.map((plan) => (
                    <div
                        key={plan.name}
                        className={`w-100 plan-wrapper ${
                            selectedPlan?.name === plan.name ? "checked" : ""
                        }`}
                    >
                        <label
                            className="form-check-label w-100"
                            htmlFor={`plan-${plan.name}`}
                        >
                            <input
                                className="form-check-input display-none"
                                type="radio"
                                name="subscriptionPlan"
                                id={`plan-${plan.name}`}
                                value={plan.name}
                                checked={selectedPlan?.name === plan.name}
                                onChange={() => handlePlanChange(plan)}
                            />
                            <div className="d-flex align-items-center justify-content-between mb-2 plan-label">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="plan-name-text">
                                        {t(plan.name)}{" "}
                                    </div>
                                    <Badge
                                        variant="success"
                                        className="plan-offer-text"
                                    >
                                        {plan.metadata?.offer_text}
                                    </Badge>
                                </div>
                                {selectedPlan?.name === plan.name && (
                                    <FontAwesomeIcon
                                        icon={faCircleCheck}
                                        className="icon"
                                        color="#707EFF"
                                        size="xl"
                                    />
                                )}
                            </div>
                            <h5>
                                {`$${plan.amount}/${lowerCase(
                                    t(plan.interval)
                                )}`}
                            </h5>
                        </label>
                    </div>
                ))}
        </Col>
    );
}

export default SubscriptionPlanComponent;
